import { render, staticRenderFns } from "./SwapDetail.vue?vue&type=template&id=6d3a3bb2&scoped=true"
import script from "./SwapDetail.vue?vue&type=script&lang=js"
export * from "./SwapDetail.vue?vue&type=script&lang=js"
import style0 from "./SwapDetail.vue?vue&type=style&index=0&id=6d3a3bb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3a3bb2",
  null
  
)

export default component.exports